import { useMemo } from "react";
import { FormSelectInput } from "form";
import { useTranslation } from "react-i18next";
import { useActionChoices } from "stores";

const AnalysisTypeInput = ({ isViewMode }) => {
  const { t } = useTranslation();
  const { actions } = useActionChoices();

  const analysisOptions = useMemo(() => {
    return [
      {
        value: actions.diagnose?.operations[1]?.operationTypeId,
        label: actions.diagnose?.operations[1]?.operationTypeName,
      },
      {
        value: actions.diagnose?.operations[2]?.operationTypeId,
        label: actions.diagnose?.operations[2]?.operationTypeName,
      },
    ];
  }, [actions]);
  return (
    <FormSelectInput
      name="diagnoseAction.operationTypeId"
      placeholder={t("ActionModal.AnalysisTypeFull")}
      shouldHaveErrorBehaviorAfterSubmit
      isViewMode={isViewMode}
      options={analysisOptions}
    />
  );
};

export default AnalysisTypeInput;
